module.exports = __webpack_public_path__ + "static/media/testimonial_bg_mobile.43137657.jpg";